module.exports = __webpack_public_path__ + "static/img/huokeUpdateOne.e58382d4.png";